import { tabletBreakpoint } from 'core/layouts/ui-blocks/ReusableStyles';
import { colorPalette } from 'core/layouts/ui-blocks/ColorPalette';

export const canvasListPageStyles = {
	myCanvasContainer: {
		width: '100%',
		flexDirection: { xs: 'column', sm: 'row' },
		justifyContent: 'space-between',
		padding: { xs: '36px 16px', sm: '36px 32px', [tabletBreakpoint]: '36px 40px' },
		backgroundColor: 'colors.dark5',
	},
	canvases: {
		width: '100%',
		padding: { xs: '24px 16px', sm: '24px 32px', [tabletBreakpoint]: '24px 40px' },
	},
	creatNewButton: {
		width: 'auto',
		padding: '8px 32px',
		borderRadius: '4px',

		color: 'colors.dark6',
		backgroundColor: 'colors.buttonGreen',
		textTransform: 'none',

		'&:hover': {
			backgroundColor: 'colors.buttonGreen',
		},
		'&.Mui-disabled': {
			color: 'colors.dark2',
			backgroundColor: 'colors.light5',
		},
	},
	buttonContainer: {
		display: 'flex',
		flexDirection: { xs: 'column', md: 'row' },
		alignItems: 'flex-end',
		gap: '16px',
	},
	downloadAppButton: {
		height: '40px',
		width: 'auto',

		display: 'flex',
		flexDirection: 'row',
		gap: '12px',

		alignItems: 'center',
		padding: '8px 16px',
		borderRadius: '4px',

		color: 'colors.light3',
		textTransform: 'none',

		cursor: 'pointer',

		backgroundColor: 'colors.light3',
	},
	betaTag: {
		padding: '2px 4px',
		borderRadius: '4px',
		backgroundColor: 'colors.dark1',
	},
	desktopAppToolbar: {
		width: '100%',
		padding: {
			xs: '36px 16px 0 16px',
			sm: '36px 32px 0 32px',
			[tabletBreakpoint]: '36px 40px 0 40px',
		},
		justifyContent: 'space-between',
	},
	desktopAppToolbarActionButton(disabled) {
		return {
			maxWidth: '290px',
			padding: '10px 24px',
			backgroundColor: 'colors.dark3',
			border: `1px solid ${colorPalette.dark1}`,
			borderRadius: '8px',
			cursor: 'pointer',
			pointerEvents: disabled ? 'none' : 'auto',
			opacity: disabled ? 0.5 : 1,
		};
	},
	desktopAppToolbarContainer: {
		justifyContent: 'space-between',
		width: '100%',
		padding: '12px 20px',
		backgroundColor: 'colors.dark5',
		borderBottom: `1px solid ${colorPalette.dark1}`,
	},
	refreshButton: {
		cursor: 'pointer',
		height: '40px',
		width: '40px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: 'colors.dark3',
		border: `1px solid ${colorPalette.dark1}`,
		borderRadius: '50%',
		'& svg': {
			height: '16px',
			width: '16px',
		},
	},
};
